function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "healthy_lifestyle");

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 124,
  y: 315.31265,
  width: 701,
  height: 390.99997,
  fill: "#3f3d56"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M297.81871,386.66964l46.1531-17.34665c-13.35809-16.20837-31.11325-32.76538-49.85211-48.25558l-63.67261,10.78018,52.5654-19.75671c-46.356-36.65988-94.50586-65.301-94.50586-65.301s-52.63038,147.377-37.16018,212.84491c8.973,37.97257,33.15313,67.94565,63.46422,83.68949l1.2333-84.596,16.46468,91.9292a101.95713,101.95713,0,0,0,54.345,2.11578c59.36835-14.02887,94.95486-78.47372,79.48465-143.94159-2.31732-9.80664-7.94217-20.3125-15.8121-31.08575Z",
  transform: "translate(-148.49998 -38.04309)",
  fill: "#d0cde1"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M483.31,744.35571H420.25a265.89362,265.89362,0,0,1-25.25-27.26l-43.96-74.08-55.08-92.85-6.13-10.32-5.04-8.5,27.24-15.13,5.79,7.72,1.13,1.5,6.64,8.84,44.72,59.57,4.89-44.72h18.16l-14.91,55.56Z",
  transform: "translate(-148.49998 -38.04309)",
  fill: "#f2f2f2"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M880.794,390.57046l-52.226-5.21164c9.305-20.33,23.03785-42.22223,38.07471-63.28625l68.45111-6.33875-59.48211-5.9357c37.65222-50.40072,79.3446-93.04352,79.3446-93.04352s94.48108,137.2017,96.48657,208.78336c1.16321,41.51868-15.50683,78.97067-42.37866,103.4632L984.64,442.31427l8.22546,99.07483a108.53281,108.53281,0,0,1-55.32593,17.05181C872.627,560.25958,818.37919,503.70547,816.3737,432.12384c-.30042-10.72245,2.61023-23.06949,7.7572-36.30619Z",
  transform: "translate(-148.49998 -38.04309)",
  fill: "#d0cde1"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M933.8,535.82568l-.31,1.11-2.55,9.03-3.48,12.29v.01l-31.25,110.57-21.08,74.57c-.36.32-.72.63-1.09.95H814.12l43.4-107.44-30.54-53.07,18.68-4.97,17.27,44.65,29.7-73.5.01-.01,4.4-10.91.75-1.86,3.84-9.53,31.17,7.87Z",
  transform: "translate(-148.49998 -38.04309)",
  fill: "#f2f2f2"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M535.521,769.65771l-24.96616,92.2992H596.045l9.83515-9.07862,3.78277,9.07862h91.54267s9.83514-59.76752-2.26965-64.30683S535.521,769.65771,535.521,769.65771Z",
  transform: "translate(-148.49998 -38.04309)",
  fill: "#2f2e41"
});

var _ref9 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 483.10294,
  cy: 315.51175,
  r: 52.202,
  fill: "#a0616a"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M592.64054,379.65585s9.83515,74.142-5.29583,82.464,90.02954,9.07861,90.02954,9.07861-23.45307-64.30679-12.86139-83.97714Z",
  transform: "translate(-148.49998 -38.04309)",
  fill: "#a0616a"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M627.82017,449.63678s-26.48578-3.956-32.15668-17.109L515.85069,467.794s14.37445,105.16052,22.69653,124.07428L527.95549,781.76251s74.142,49.17578,174.00665,22.69653l24.96619-208.808,27.23584-124.07431-87.2-35.02179S649.76011,448.12368,627.82017,449.63678Z",
  transform: "translate(-148.49998 -38.04309)",
  fill: "#67b95f"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M683.04838,688.70678s-96.082-3.02618-89.273,25.72272,95.32538-1.51312,95.32538-1.51312Z",
  transform: "translate(-148.49998 -38.04309)",
  fill: "#a0616a"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M588.1757,304.17657l-9.7605-3.90756s20.40827-22.46835,48.80262-20.5145l-7.98609-8.792s19.521-7.815,37.26734,12.69949c9.32891,10.784,20.12255,23.46009,26.85125,37.7395h10.45282l-4.36261,9.606,15.26917,9.606L689.0374,338.888a53.67976,53.67976,0,0,1,.42529,15.93332,20.61547,20.61547,0,0,1-7.5492,13.48629h0S669.8087,343.25186,669.8087,339.3443v9.76886s-9.7605-8.79194-9.7605-14.6532l-5.32385,6.83819-2.66193-10.74579-32.83069,10.74579,5.32385-8.79193-20.40826,2.93064,7.98608-10.74579s-23.07019,12.69949-23.9577,23.44528c-.88721,10.74563-7.63995,20.92782-7.63995,20.92782S562.44352,318.82977,588.1757,304.17657Z",
  transform: "translate(-148.49998 -38.04309)",
  fill: "#2f2e41"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M651.65153,658.02166v12.87726a.4502.4502,0,0,1-.449.449H650.883v67.08221a6.99978,6.99978,0,0,1-6.99939,6.99939H601.96775a6.99808,6.99808,0,0,1-6.99743-6.99872V673.70062H594.739a.31718.31718,0,0,1-.31762-.31568v-7.32873a.31757.31757,0,0,1,.3175-.31763h.23151v-2.7605h-.2334a.33262.33262,0,0,1-.33136-.33331V655.416a.33218.33218,0,0,1,.33136-.33136h.23334v-3.76831h-.23725a.29366.29366,0,0,1-.29406-.29333v-3.9455a.29537.29537,0,0,1,.29406-.296h.23725V638.794a6.99768,6.99768,0,0,1,6.99743-6.99743h41.91584A6.99931,6.99931,0,0,1,650.883,638.794v18.77875h.31958A.45014.45014,0,0,1,651.65153,658.02166Z",
  transform: "translate(-148.49998 -38.04309)",
  fill: "#3f3d56"
});

var _ref15 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 474.49598,
  cy: 623.63586,
  r: 6.86212,
  fill: "#f2f2f2"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M730.711,471.57675H754.1641s74.89856,163.415,56.74134,183.08523-127.85706,73.38544-127.85706,73.38544-8.32208-41.61029-15.88757-41.61029L742.8159,639.531l-37.071-88.51642Z",
  transform: "translate(-148.49998 -38.04309)",
  fill: "#67b95f"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M562.75682,681.89782s85.49023,45.393,69.60266,65.06336-92.2992-34.80133-92.2992-34.80133Z",
  transform: "translate(-148.49998 -38.04309)",
  fill: "#a0616a"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M526.44236,468.55056H515.85069s-15.131,14.37445-19.67032,46.90616l-43.95251,97.94147a22.13514,22.13514,0,0,0,.30822,18.78c9.75431,19.97772,35.42835,65.05963,73.90634,78.46863l19.67035,15.131s-2.26965-37.071,28.74891-37.071L521.90306,631.209,542.33,564.6325Z",
  transform: "translate(-148.49998 -38.04309)",
  fill: "#67b95f"
});

var _ref19 =
/*#__PURE__*/
React.createElement("rect", {
  x: 475,
  width: 260.52106,
  height: 200.97339,
  fill: "#3f3d56"
});

var _ref20 =
/*#__PURE__*/
React.createElement("rect", {
  x: 520.07428,
  y: 72.36696,
  width: 36.39026,
  height: 95.93791,
  fill: "#d0cde1"
});

var _ref21 =
/*#__PURE__*/
React.createElement("rect", {
  x: 587.06543,
  y: 109.58426,
  width: 36.39026,
  height: 58.72061,
  fill: "#d0cde1"
});

var _ref22 =
/*#__PURE__*/
React.createElement("rect", {
  x: 654.05652,
  y: 32.66851,
  width: 36.39026,
  height: 135.63636,
  fill: "#d0cde1"
});

var _ref23 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 605.26056,
  cy: 72.36696,
  r: 18.19513,
  fill: "#67b95f"
});

var _ref24 =
/*#__PURE__*/
React.createElement("rect", {
  x: 151.47895,
  y: 38.65188,
  width: 260.52106,
  height: 200.9734,
  fill: "#3f3d56"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M339.67735,236.31582s2.48117-66.99112,52.10422-56.23947,123.23062-51.27716,123.23062-51.27716",
  transform: "translate(-148.49998 -38.04309)",
  fill: "#67b95f"
});

var _ref26 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "191.591 194.965 191.591 66.772 175.05 66.772 175.05 194.965 175.05 210.678 175.05 211.506 388.429 211.506 388.429 194.965 191.591 194.965",
  fill: "#d0cde1"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M586.84837,564.67454l9.05448,10.56363c3.364-.64138,6.87693-1.3951,10.49515-2.24156l-2.60062-8.32207,6.35878,7.41859C648.488,562.66533,696,544.33573,696,544.33573s-51.29412,3.76111-89.59308-4.60615c-16.94544-3.7021-34.38014,4.69808-41.33386,20.58831-4.04177,9.236-3.407,17.2379,10.92794,17.2379a94.68106,94.68106,0,0,0,14.448-1.359Z",
  transform: "translate(-148.49998 -38.04309)",
  fill: "#2f2e41"
});

var SvgGuyOnPhone = function SvgGuyOnPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "b25ce53c-8007-4f89-bc74-8ca6ee2e35ce",
    "data-name": "Layer 1",
    width: 903.00005,
    height: 823.91381,
    viewBox: "0 0 903.00005 823.91381",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, React.createElement("ellipse", {
    cx: 299.54433,
    cy: 523.40044,
    rx: 32.15341,
    ry: 10.96997,
    transform: "translate(-370.06887 181.85144) rotate(-30)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _ref5, _ref6, React.createElement("ellipse", {
    cx: 916.4446,
    cy: 531.69856,
    rx: 11.67755,
    ry: 34.22724,
    transform: "translate(15.86718 1239.94869) rotate(-74.90007)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGuyOnPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/guyOnPhone.0f42eb58.svg";
export { ForwardRef as ReactComponent };